export default "__VITE_ASSET__Dzlp7tfI__"